import React from "react";
import { rupiah } from "@/lib/format";

// F1.5-B: the calculation breakdown exactly as computed by the server
// (preview, saved nota). The page never recalculates money.
export default function RincianHitung({ rincian, testid = "rincian" }) {
  if (!rincian) return null;
  return (
    <div data-testid={testid} className="rounded-lg border border-slate-700 bg-slate-950/60 p-3 text-sm space-y-1.5">
      {rincian.baris.map((b, i) => (
        <div key={i} data-testid={`${testid}-baris-${i}`}>
          <div className="text-slate-200">{b.nama}{b.detail ? <span className="text-slate-500"> · {b.detail}</span> : null}</div>
          <div className="font-mono text-slate-300 pl-3">{b.hitung}{b.keterangan && <span className="ml-2 text-xs text-cyan-300">({b.keterangan})</span>}</div>
          {b.diskon > 0 && <div className="font-mono text-slate-400 pl-3">Diskon −{rupiah(b.diskon)} → <b className="text-slate-200">{rupiah(b.jumlah)}</b></div>}
        </div>
      ))}
      <div className="border-t border-slate-700 pt-1.5 font-mono text-slate-300">Subtotal {rupiah(rincian.subtotal)}</div>
      {rincian.diskon > 0 && <div className="font-mono text-slate-300">Diskon nota −{rupiah(rincian.diskon)}</div>}
      {rincian.ppn && (
        <div data-testid={`${testid}-ppn`} className="font-mono text-slate-300">
          {rincian.ppn.mode === "INKLUSIF"
            ? <>PPN {rincian.ppn.tarif}% termasuk dalam harga {rupiah(rincian.ppn.ppn)} (DPP {rupiah(rincian.ppn.dpp)})</>
            : <>DPP {rupiah(rincian.ppn.dpp)} + PPN {rincian.ppn.tarif}% {rupiah(rincian.ppn.ppn)}</>}
          <span className="ml-2 text-xs text-cyan-300">(customer instansi)</span>
        </div>
      )}
      <div data-testid={`${testid}-total`} className="font-mono text-lg font-semibold text-amber-300">Grand total {rupiah(rincian.total)}</div>
      {rincian.minimal_bayar_produksi > 0 && (
        <div data-testid={`${testid}-minimal`} className="font-mono text-amber-200">Minimal bayar sebelum produksi {rupiah(rincian.minimal_bayar_produksi)}</div>
      )}
    </div>
  );
}
